import { render, staticRenderFns } from "./typeDetail.vue?vue&type=template&id=39da4d00&scoped=true&"
import script from "./typeDetail.vue?vue&type=script&lang=js&"
export * from "./typeDetail.vue?vue&type=script&lang=js&"
import style0 from "./typeDetail.vue?vue&type=style&index=0&id=39da4d00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da4d00",
  null
  
)

export default component.exports